import { useMemo } from 'react';

import { Comment } from '../../../../../../../../db/comments/types';
import { selectCurrentCourse } from '../../../../../../../../db/courses/selectors';
import { selectCourseUserProfile } from '../../../../../../../../db/user-profiles/selectors';
import { useAppSelector } from '../../../../../../../../store/hooks';
import { formatDistanceToNowStrict } from '../../../../../../../../utils/datetime';

export interface Props {
  creator: Comment['createdBy'];
  createdOn: UnixTime;
}

function useCommentCreatorVM({ creator, createdOn }: Props) {
  const currentCourse = useAppSelector((state) => selectCurrentCourse(state));
  const courseUserProfile = useAppSelector((state) => selectCourseUserProfile(state, creator.avatar));
  const courseUserDetails = courseUserProfile?.courseUserDetails[currentCourse?.id ?? ''];
  const { role: courseRole, isRemovedMember } = courseUserDetails || {};

  const createdOnFormattedTime = useMemo(
    () => formatDistanceToNowStrict(createdOn, { addSuffix: true }),
    [createdOn]
  );

  return { courseRole, isRemovedMember, createdOnFormattedTime };
}

export default useCommentCreatorVM;
